import { Stack, Image } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import SpaceDoorSeal from '../assets/SpaceDoorLogo.png';

const Home = () => {
  return (
    <Stack>
      <Header pageHeader={'Home Page'} zIndex="1000" />
      <Stack
        justify="center"
        align="center"
        alignContent="center"
        width="100%"
        mt="10px"
      >
        <Image
          src={SpaceDoorSeal}
          alt="Space Door Seal"
          opacity={0.75}
          maxW={{ base: '70vw', sm: '600px', md: '800px' }}
          maxH={{ base: 'auto', md: '800px' }}
          objectFit="contain"
          mx="auto"
          zIndex={0}
        />
      </Stack>
    </Stack>
  );
};

export default Home;
